import { render, staticRenderFns } from "./RevisionsModal.vue?vue&type=template&id=7171ded0"
import script from "./RevisionsModal.vue?vue&type=script&lang=js"
export * from "./RevisionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports